import React from "react";
import Loading from "../components/loading";

const Test = () => {
  return (
    <div>
      <Loading />
    </div>
  );
};

export default Test;
